// extracted by mini-css-extract-plugin
export var layoutContainer = "_3w-0";
export var layoutContainerOpen = "_3w-5";
export var layoutContainerResizing = "_3w-1";
export var mainContent = "_3w-2";
export var resizeDivider = "_3w-3";
export var slidePanel = "_3w-4";